import { theme } from '@/utils/theme';

export const classes = {
  paper: 'flex flex-col rounded-2xl dark:bg-[#332e43]',
  body: 'flex',
  timeSection: 'flex flex-col items-start pt-5',
  footer: 'place-between px-4 py-3 border-t border-grey-3 dark:border-white/10',
  cancelButton: 'py-1',
  cancelText: 'text-grey-6 dark:text-mauve-2',
};

export const styles = {
  calendar: {
    '& .MuiPickersYear-yearButton.Mui-selected': {
      backgroundColor: theme.palette['orange-2'].main,
    },
    '& .MuiPickersDay-today:not(.Mui-selected)': {
      border: `1px solid ${theme.palette['grey-6'].main}`,
    },
    '.dark & .MuiPickersDay-today:not(.Mui-selected)': {
      border: '1px solid rgba(255,255,255,0.1)',
    },
    '& .MuiPickersDay-root:focus.Mui-selected, & .MuiPickersDay-root.Mui-selected, & .MuiPickersDay-root.Mui-selected:hover':
      {
        backgroundColor: theme.palette['orange-2'].main,
      },
  },
};
